import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const listAssets = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('assets.getlist'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets');
        Store.dispatch(loadingActions.loadingEnd('assets.getlist'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.getlist'));
        return e.response.data;
    }
};

export const getAssetsContent = async (tableId, id) => {
    Store.dispatch(loadingActions.loadingStart('assets.geAssetContent'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets/'+id+'/content');
        Store.dispatch(loadingActions.loadingEnd('assets.geAssetContent'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.geAssetContent'));
        return e.response.data;
    }
};

export const addAsset = async (tableId, data) => {
    Store.dispatch(loadingActions.loadingStart('assets.addAsset'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets', {...data});
        Store.dispatch(loadingActions.loadingEnd('assets.addAsset'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.addAsset'));
        return e.response.data;
    }
};

export const editAsset = async (tableId, id, data) => {
    Store.dispatch(loadingActions.loadingStart('assets.editAsset'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets/'+id, {...data});
        Store.dispatch(loadingActions.loadingEnd('assets.editAsset'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.editAsset'));
        return e.response.data;
    }
};

export const editAssetContent = async (tableId, id, data) => {
    Store.dispatch(loadingActions.loadingStart('assets.editAssetContent'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets/'+id+'/content', {...data});
        Store.dispatch(loadingActions.loadingEnd('assets.editAssetContent'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.editAssetContent'));
        return e.response.data;
    }
};

export const removeAsset = async (tableId, id) => {
    Store.dispatch(loadingActions.loadingStart('assets.deleteAsset'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/table/'+tableId+'/assets/'+id);
        Store.dispatch(loadingActions.loadingEnd('assets.deleteAsset'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('assets.deleteAsset'));
        return e.response.data;
    }
};